import { GRID_SPACING, DRAWER_WIDTH, APP_DRAWER_WIDTH } from "@/config";

// theme constant
export const gridSpacing = GRID_SPACING;
export const drawerWidth = DRAWER_WIDTH;
export const appDrawerWidth = APP_DRAWER_WIDTH;
